import styled from 'styled-components';

export const MenuLabelTag = styled.p`
  margin: 0;
  color: ${props => props.theme.colors.black};
  font-family: ${props => props.theme.fonts.gtEesti};
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 17px;
  opacity: ${props => (props.active || props.done ? 1 : 0.3)};
  cursor: ${props => (props.withCursor ? 'pointer' : 'default')};

  span {
    display: inline-block;
    margin-left: 2px;
    margin-right: 10px;
    width: 8px;
    height: 8px;
    border-radius: 50%;

    background-color: ${props => props.theme.colors.black};
    opacity: ${props => (!props.done && !props.active ? 0.3 : 1)};
  }

  svg {
    margin-right: 6px;
    padding-bottom: 2px;
  }
`;
